import { render, staticRenderFns } from "./DatepickerHighlightDates.vue?vue&type=template&id=61d5e74a&"
import script from "./DatepickerHighlightDates.vue?vue&type=script&lang=js&"
export * from "./DatepickerHighlightDates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports